
import {Link} from 'react-router-dom'
import proyects from '../../api/projects-cluster';


const ProjectSection = (props) => {
    
    const ClickHandler = () =>{
        window.scrollTo(10, 0);
     }

    return(

        <section className="wpo-blog-section section-padding">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-6">
                        <div className="wpo-section-title">
                            <span>Conoce sobre nuestros proyectos</span>
                            <h2>PROYECTOS</h2>
                            <p className=' mx-auto'>Donde buscamos fomentar la preservación de la memoria histórica y la tradición oral del Caribe colombiano a través de medios digitales</p>
                        </div>
                    </div>
                </div>
                <div className="wpo-blog-items">
                    <div className="row justify-content-center">
                        {proyects.slice(0,3).map((blog, Bitem) => (
                            <div className="col col-lg-4 col-md-5 col-12" key={Bitem}>
                                <div className="wpo-blog-item">
                                    <div className="wpo-blog-img">
                                        <img src={blog.screens} alt=""/>
                                    </div>
                                    <div className="wpo-blog-content">
                                        <div className="wpo-blog-content-top">
                                            <h2><Link onClick={ClickHandler} to={`${blog.proyectLink}`}>{blog.title}</Link></h2>
                                            {/* <p className='description'>{blog.description}</p> */}
                                        </div>
                                        
                                        <div className="wpo-blog-content-btm">
                                            <div className="wpo-blog-content-btm-left">
                                                <div className="wpo-blog-content-btm-left-img">
                                                    <img className='img-fluid w-100' src={blog.authorImg} alt=""/>
                                                </div>
                                                <div className="wpo-blog-content-btm-left-text">
                                                    <h4><Link onClick={ClickHandler} to={`${blog.proyectLink}`}>{blog.author}</Link></h4>
                                                </div>
                                            </div>
                                            <div className="wpo-blog-content-btm-right">
                                                <span><i className="fi flaticon-chat-comment-oval-speech-bubble-with-text-lines"></i> {blog.comment}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ProjectSection;